import React from 'react';
import Dashboard from './views/dashboard/Dashboard' ;
import Articles from './views/articles/Articles' ;
import Cartable from './views/cartable/Cartable' ;
import ArticleActions from 'views/articleActions/ArticleActions';
import { Icon } from '@chakra-ui/react';
import { FaRegNewspaper } from 'react-icons/fa';
import { MdAdminPanelSettings } from 'react-icons/md';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { RiArticleLine } from 'react-icons/ri';
import { TbChecklist } from 'react-icons/tb';
import { RiLogoutBoxRLine } from 'react-icons/ri';
import SignOut from 'views/auth/signout/SignOut';

import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
} from 'react-icons/md';
import { ArticlesProvider } from './contexts/ArticlesContext'; // Import ArticlesProvider

// Admin Imports
import { DocumentIcon } from 'components/icons/Icons';
import ProtectedRoute from 'components/ProtectedRoute';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import ReviewerList from 'views/reviewerlist/ReviewerList';
import JournalList from 'views/journal_list/JournalList';
import AdminList from 'views/adminList/AdminList';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <ProtectedRoute><Dashboard/></ProtectedRoute>, 
  },
  {
    name: 'My Cartable',
    layout: '/admin',
    path: '/cartable',
    icon: <Icon as={TbChecklist} width="20px" height="20px" color="inherit" />,
    component:<ProtectedRoute> <Cartable /> </ProtectedRoute> ,
    secondary: true,
  },
  {
    name: 'Articles',
    layout: '/admin',
    icon: <Icon as={RiArticleLine} width="20px" height="20px" color="inherit" />,
    path: '/articles',
    component: (
    <ProtectedRoute>
        <ArticlesProvider> {/* Wrapping Articles component with ArticlesProvider */}
          <Articles />
        </ArticlesProvider>
    </ProtectedRoute>    
    ),
  },
  // {
  //   name: 'Profile',
  //   layout: '/admin',
  //   path: '/profile',
  //   icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
  //   component: <Profile />,
  // },
  {
    category: 'Management',
    name: 'Management',
    items: [
 
      {
        name: 'Journal List',
        layout: '/admin',
        path: '/management/journal_list',
        icon: <Icon as={FaRegNewspaper} w="20px" h="20px" color="inherit" />,

        component: <ProtectedRoute> <JournalList /> </ProtectedRoute> ,
      },
      {
        name: 'Admin List',
        layout: '/admin',
        path: '/management/admin_list',
        icon: <Icon as={MdAdminPanelSettings} w="20px" h="20px" color="inherit" />,
        component: <ProtectedRoute><AdminList/></ProtectedRoute>,
      },
      {
        name: 'Reviewer List',
        layout: '/admin',
        icon: <Icon as={HiOutlineUserGroup} w="20px" h="20px" color="inherit" />,
        path: '/management/reviewer_list',
        component:<ProtectedRoute> <ReviewerList/> </ProtectedRoute>,
      },
    ]
  },


  {
    name: 'Sign Out',
    layout: '/auth',
    path: '/sign-out', // تغییر مسیر چون این الان logout واقعی انجام میده
    icon: <Icon as={RiLogoutBoxRLine} width="20px" height="20px" color="inherit" />,
    component: <SignOut />,
  },

  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    hideInSidebar: true,
    component: <SignInCentered />,
  },
  
  // {
  //   name: 'RTL Admin',
  //   layout: '/rtl',
  //   path: '/rtl-default',
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   component: <RTL />,
  // },
  {
    name: 'Article Actions',
    layout: '/admin',
    path: '/cartable/article_actions/:id',
    component: <ProtectedRoute><ArticleActions /></ProtectedRoute>,
    hideInSidebar: true, // این ویژگی باعث می‌شود که روت در سایدبار نمایش داده نشود
  }
];

export default routes;
